import Splide from '@splidejs/splide';

export default {
  init() {
    // JavaScript to be fired on the about us page

    $(document).on('change', '.variation-radios input', function() {
      $('select[name="'+$(this).attr('name')+'"]').val($(this).val()).trigger('change');
    });

    $(document).on('woocommerce_update_variation_values', function() {
      $('.variation-radios input').each(function(index, element) {
        $(element).removeAttr('disabled');
        var thisName = $(element).attr('name');
        var thisVal  = $(element).attr('value');
        if($('select[name="'+thisName+'"] option[value="'+thisVal+'"]').is(':disabled')) {
          $(element).prop('disabled', true);
        }
      });
    });

    if($('#related-prodict-slider').length > 0){
      new Splide('#related-prodict-slider', {
        type: 'loop',
        arrows: true,
        pagination: false,
        gap: '15px',
        perMove: 1,
        perPage: 4,
        autoplay: true,
        breakpoints: {
          1410: {
            perPage: 4,
          },
          1199: {
            perPage: 3,
          },
          992: {
            perPage: 2,
          },
          767: {
            perPage: 1,
          },
        },
      }).mount();
    }

    if($('#up-sell-slider').length > 0){
      new Splide('#up-sell-slider', {
        type: 'loop',
        arrows: $(this).data('arrows'),
        pagination: false,
        gap: '15px',
        perMove: 1,
        perPage: 4,
        autoplay: true,
        breakpoints: {
          1410: {
            perPage: 4,
          },
          1199: {
            perPage: 3,
          },
          992: {
            perPage: 2,
          },
          767: {
            perPage: 1,
          },
        },
      }).mount();
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js